<script setup lang="ts">
import {watch} from 'vue'
import {useRegisterSW} from 'virtual:pwa-register/vue'
import {toast} from 'vue-sonner'

const intervalMS = 60 * 60 * 1000

const {offlineReady, needRefresh, updateServiceWorker} = useRegisterSW({
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return
    setInterval(() => registration.update(), intervalMS)
  },
})

watch(offlineReady, (val) => {
  if (val) toast.success('App ready for offline use')
})

watch(needRefresh, (val) => {
  if (val) {
    toast('New version available', {
      action: {label: 'Reload', onClick: () => updateServiceWorker()},
      duration: Infinity,
    })
  }
})
</script>

<template />
